
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/log-in",
      function () {
        return require("private-next-pages/log-in.tsx");
      }
    ]);
  